import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../core/services/AuthenticationService';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})

export class ToolbarComponent {

  @Input() showButton: boolean = false;
  @Output() buttonPressed = new EventEmitter<boolean>();
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  constructor(private authenticationService: AuthenticationService, private breakpointObserver: BreakpointObserver) {

  }

  onButtonClicked() {
    this.buttonPressed.emit(true); 
  }

  logOut() {
    // reset login status
    this.authenticationService.logout();
    location.reload(true);

  }
}
